// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"Dashboard_dashboard__3-njO","container":"Dashboard_container__205D7","noScroll":"Dashboard_noScroll__3xK8T"};